import React, { useState, useEffect } from "react";
import Login from "../Assets/Login_Register/Login.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';

const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember_me: false,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(""); // State for success message
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState({ num1: 0, num2: 0, num3: 0, answer: "" });
  const [captchaError, setCaptchaError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) - 1;
    const num3 = Math.floor(Math.random() * 10) * 1;

    setCaptcha({ num1, num2, num3, answer: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptchaChange = (e) => {
    setCaptcha({ ...captcha, answer: e.target.value });
    setCaptchaError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setSuccess(""); // Clear success message on submit

    // Check CAPTCHA
    if (parseInt(captcha.answer) !== captcha.num1 + captcha.num2) {
      setCaptchaError("Incorrect CAPTCHA. Please try again.");
      setIsLoading(false);
      generateCaptcha();
      return;
    }

    try {
      const response = await axios.post("http://127.0.0.1:8000/homeLogin/login/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const storage = formData.rememberMe ? localStorage : sessionStorage;
      storage.setItem("access_token", response.data.access);
      storage.setItem("refresh_token", response.data.refresh);

      setSuccess("Login successful!"); // Set success message
      setTimeout(() => navigate("/ELanding"), 2000); // Redirect after 2 seconds
    } catch (error) {
      if (error.response) {
        setError(error.response.data.detail || "Invalid email or password.");
      } else if (error.request) {
        setError("No response from server. Please try again later.");
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleClose = () => {
    navigate("/");
  };

  const handleForgotPassWord = (event) => {
    event.preventDefault();
    navigate("/ForgotPassword");
  };

  const handleRegisterClick = () => {
    navigate("/HomeRegister");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="flex w-full max-w-6xl bg-white rounded-lg shadow-lg overflow-hidden relative">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-red-600"
        >
          <IoClose />
        </button>

        <div className="w-1/2 hidden md:block relative">
          <img src={Login} alt="Login" className="object-cover h-full w-full" />
          <button
            onClick={handleForgotPassWord}
            className="absolute bottom-5 left-1/2 transform -translate-x-1/2 bg-[#0077af] text-white py-2 px-4 rounded-lg shadow-lg hover:bg-[#005f8f]"
          >
            Forgot Password?
          </button>
        </div>

        <div className="w-full md:w-1/2 p-10">
          <h3 className="text-gray-800 text-3xl font-extrabold mb-6 text-center">Login</h3>
          {error && <p className="text-red-600 text-center mb-4">{error}</p>}
          {success && <p className="text-green-600 text-center mb-4">{success}</p>} {/* Success Message */}
          <form className="space-y-6" onSubmit={handleLogin}>
            <div>
              <label className="text-gray-800 text-sm mb-2 block font-bold">Email</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-none focus:ring-2 focus:ring-[#0077af]"
                placeholder="Enter your email"
              />
            </div>
            <div>
              <label className="text-gray-800 text-sm mb-2 block font-bold">Password</label>
              <div className="relative">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full text-sm text-gray-800 border border-gray-300 px-4 py-3 rounded-lg outline-none focus:ring-2 focus:ring-[#0077af] pr-10"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute inset-y-0 right-3 flex items-center text-gray-500"
                >
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </button>
              </div>
            </div>
            {/* captcha */}
            <div>
              <label className="text-gray-800 text-sm mb-2 block font-bold">CAPTCHA</label>
              <div className="flex items-center space-x-2 border border-gray-300 rounded-lg p-3 shadow-sm bg-gray-50">
                <span className="text-gray-800 font-bold">{`${captcha.num1} + ${captcha.num2} = `}</span>
                <input
                  type="number"
                  value={captcha.answer}
                  onChange={handleCaptchaChange}
                  className="w-16 text-center text-sm text-gray-800 border border-gray-300 px-2 py-2 rounded-lg outline-none focus:ring-2 focus:ring-[#0077af]"
                  placeholder="?"
                  required
                />
              </div>
              {captchaError && <p className="text-red-600 text-sm mt-1">{captchaError}</p>}
            </div>

            <button
              type="submit"
              className="w-full py-3 rounded-lg text-white bg-[#0077af] hover:bg-[#005f8f] shadow-lg font-bold"
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>
          </form>

          <p className="text-sm text-center text-gray-800 mt-6">
            Don't have an account?&nbsp;
            <button
              onClick={handleRegisterClick}
              className="text-[#0077af] font-semibold hover:underline"
            >
              Register here
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
